import { baseRequest } from '../../utils/httpClient';
import { apiEndpoints } from '../../constants/apiEndpoints';

export const uploadMedia = payload => {
  return baseRequest(apiEndpoints.UPLOAD_MEDIA, payload, undefined, undefined, true, true, true);
};
